import {
  Component,
  Input,
  OnInit,
  Output,
  EventEmitter,
  ViewChildren,
  QueryList,
  ChangeDetectionStrategy
} from '@angular/core';
import {
  ExecutiveAssociateAudit,
  PhoneNumberAudit,
  ExecutiveAssociateSkeleton,
  EmailAddressAudit
} from '../../+models/person-profile-audit.model';
import { PersonProfileExecutiveAssociatePhoneNumberAuditListComponent } from '../person-profile-executive-associate-phone-number-audit-list/person-profile-executive-associate-phone-number-audit-list.component';
import { PersonProfileExecutiveAssociateEmailAuditListComponent } from '../person-profile-executive-associate-email-audit-list/person-profile-executive-associate-email-audit-list.component';

@Component({
  selector: 'sd-portal-person-profile-executive-associate-audit-list',
  templateUrl: './person-profile-executive-associate-audit-list.component.html',
  styleUrls: ['./person-profile-executive-associate-audit-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PersonProfileExecutiveAssociateAuditListComponent implements OnInit {
  @Input() executiveAssociate: ExecutiveAssociateSkeleton;
  @Input() loading: boolean;
  @Input() executiveAssociateAudits: ExecutiveAssociateAudit[];

  @Input() executiveAssociatePhoneNumberAuditsLoading: boolean;
  @Input() executiveAssociatePhoneNumberAudits: PhoneNumberAudit[];

  @Input() executiveAssociateEmailAuditsLoading: boolean;
  @Input() executiveAssociateEmailAudits: EmailAddressAudit[];

  @Output() loadExecutiveAssociateAudits = new EventEmitter<number>();
  @Output() nextPage = new EventEmitter<number>();

  @Output() loadExecutiveAssociatePhoneNumberAudits = new EventEmitter<number>();
  @Output() nextExecutiveAssociatePhoneNumberAuditPage = new EventEmitter<number>();

  @Output() loadExecutiveAssociateEmailAudits = new EventEmitter<number>();
  @Output() nextExecutiveAssociateEmailAuditPage = new EventEmitter<number>();

  @ViewChildren(PersonProfileExecutiveAssociatePhoneNumberAuditListComponent)
  personProfileExecutiveAssociatePhoneNumberAuditLists: QueryList<PersonProfileExecutiveAssociatePhoneNumberAuditListComponent>;

  @ViewChildren(PersonProfileExecutiveAssociateEmailAuditListComponent)
  personProfileExecutiveAssociateEmailAuditLists: QueryList<PersonProfileExecutiveAssociateEmailAuditListComponent>;

  constructor() {}

  ngOnInit() {}

  loadData() {
    this.loadExecutiveAssociateAudits.emit(this.executiveAssociate.executiveAssociateId);
  }

  onNextPage() {
    this.nextPage.emit(this.executiveAssociate.executiveAssociateId);
  }

  executiveAssociatePhoneNumberAuditOpened(executiveAssociatePhoneNumberId: number) {
    setTimeout(() => {
      const match = this.personProfileExecutiveAssociatePhoneNumberAuditLists.find(
        p => p.executiveAssociatePhoneNumber === executiveAssociatePhoneNumberId
      );

      if (!match) {
        return;
      }

      match.loadData();
    });
  }

  executiveAssociateEmailAuditOpened(executiveAssociateEmailId: number) {
    setTimeout(() => {
      const match = this.personProfileExecutiveAssociateEmailAuditLists.find(
        p => p.executiveAssociateEmail === executiveAssociateEmailId
      );

      if (!match) {
        return;
      }

      match.loadData();
    });
  }
}
